// extracted by mini-css-extract-plugin
export var wordContainer = "_na-0";